export default function getProfessionalIdFeedbackMessage(doesIdExist, userName) {
  if (doesIdExist === undefined) return '';
  if (doesIdExist) return 'feedback.usernameTaken';
  if (!userName.isValid) return 'feedback.requiredField';
  return '';
}
